import {
  AmexIcon,
  DamenkomLogoIcon,
  FacebookIcon,
  LinkedinIcon,
  MadaIcon,
  MastercardIcon,
  SaudiBusinessCenterIcon,
  VisaIcon,
} from "@assets/icons";
import {
  DAMENKOM_ATTESTATION_NUMBER,
  DAMENKOM_REGISTRATION_NUMBER,
} from "@config/constants";
import { urls } from "@config/urls";
import { useStoreInfoCtx } from "@contexts/StoreInfoContext";
import { cn } from "@utils/cn";
import { getSizedImage, ImageSize } from "@utils/get-sized-image";
import { useTranslation } from "react-i18next";

import { Link } from "react-router";

export function Footer({ hideBranding = false }: { hideBranding?: boolean }) {
  const { t } = useTranslation("common");
  const { storeInfo } = useStoreInfoCtx();

  const showMerchantBranding = Boolean(storeInfo.logo);

  return (
    <footer className="bg-primary-50 p-6">
      <div className="container mx-auto">
        <div className="flex flex-col items-center justify-between gap-5 md:flex-row">
          <div className="flex flex-col gap-2 md:items-start">
            {(!hideBranding || showMerchantBranding) && (
              <div
                className={cn(
                  "mb-2 flex flex-col gap-1",
                  showMerchantBranding && "flex-row items-center gap-2",
                )}>
                <Link
                  title="Home Page"
                  to={urls.home}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-fit">
                  {storeInfo.logo ? (
                    <img
                      src={getSizedImage(storeInfo.logo, ImageSize.small)}
                      alt={storeInfo.name || "Store Logo"}
                      className="h-[60px]"
                      loading="lazy"
                    />
                  ) : (
                    <DamenkomLogoIcon className="h-[60px]" />
                  )}
                </Link>
                <p className="text-sm font-bold text-dark">
                  {showMerchantBranding ? storeInfo.name : t("subBrand")}
                </p>
              </div>
            )}
            <div className="flex flex-col gap-3">
              <p className="text-dark">
                {t("registrationNumber")}:{" "}
                <span className="font-bold text-brandGray-900">
                  {DAMENKOM_REGISTRATION_NUMBER}
                </span>
              </p>
              <p className="text-dark">
                {t("attestationNumber")}:{""}
                <span className="font-bold text-brandGray-900">
                  {DAMENKOM_ATTESTATION_NUMBER}
                </span>
              </p>
            </div>
          </div>

          <div className="flex flex-col gap-6">
            <div className="flex items-center gap-6">
              <Link
                title="Post Sale Service"
                to={urls.postSaleService}
                target="_blank"
                rel="noopener noreferrer"
                className="text-sm font-bold text-primary-700">
                {t("postSaleService")}
              </Link>
              <hr className="h-[40px] w-px bg-gray" />
              <div className="flex items-center gap-6">
                <Link
                  title="Facebook"
                  to={urls.facebook}
                  target="_blank"
                  rel="noopener noreferrer">
                  <FacebookIcon title="Facebook" />
                </Link>
                {/* Account is currently suspended, will be uncommented when it's reactivated */}
                {/* <Link
                  title="Twitter"
                  to={urls.twitter}
                  target="_blank"
                  rel="noopener noreferrer">
                  <TwitterIcon title="Twitter" />
                </Link> */}
                <Link
                  title="LinkedIn"
                  to={urls.linkedin}
                  target="_blank"
                  rel="noopener noreferrer">
                  <LinkedinIcon title="LinkedIn" />
                </Link>
              </div>
            </div>

            <div className="flex items-center justify-center gap-3 md:justify-end">
              <MadaIcon title="Mada" />
              <AmexIcon title="Amex" />
              <VisaIcon title="Visa" />
              <MastercardIcon title="Mastercard" />
            </div>
            <SaudiBusinessCenterIcon title="Saudi Business Center" />
          </div>
        </div>

        {!hideBranding && (
          <p className="mt-4 text-center text-xs text-secondary">
            {t("allRightsReserved")}, Taager & Damenkom ©{" "}
            {new Date().getFullYear()}
          </p>
        )}
      </div>
    </footer>
  );
}
